module.exports = __webpack_public_path__ + "images/vpza96b24ecff953b167c51866bc177212b.png";